var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvestigative = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Content-Ink-Pen-Write--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Content Ink Pen Write Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.68 5.32a4.49 4.49 0 0 0 -6.36 0c-1.23 1.22 -2.87 8 -3.06 8.81a0.49 0.49 0 0 0 0.14 0.47 0.5 0.5 0 0 0 0.47 0.14c0.77 -0.19 7.58 -1.83 8.81 -3.06a4.49 4.49 0 0 0 0 -6.36ZM15.5 10A1.5 1.5 0 1 1 17 8.5a1.5 1.5 0 0 1 -1.5 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.85 4.15 -4 -4a0.49 0.49 0 0 0 -0.41 -0.15 0.52 0.52 0 0 0 -0.37 0.24l-1.5 2.5a0.49 0.49 0 0 0 0.08 0.61l3 3a0.47 0.47 0 0 0 0.35 0.15 0.48 0.48 0 0 0 0.26 -0.07l2.5 -1.5a0.52 0.52 0 0 0 0.24 -0.37 0.49 0.49 0 0 0 -0.15 -0.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18H5a0.91 0.91 0 0 1 -1 -1 0.91 0.91 0 0 1 1 -1h2a1 1 0 0 0 0 -2H5a2.91 2.91 0 0 0 -3 3 2.91 2.91 0 0 0 3 3h12a1 1 0 1 1 0 2H1a1 1 0 0 0 0 2h16a3 3 0 0 0 0 -6Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvestigative);
export default ForwardRef;